import React, { useEffect, useState } from "react";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { tagCategoryApplication } from "../apiClient/apiDataFetcher.js";
import NoDataFound from "../components/NoDataFound.jsx";
import ApplicationSkeleton from "../components/Skeleton/Application.jsx";
import ApplicationCard from "../components/Application/Card.jsx";
// import {defaultlogo} from '../assets/Icons'

const { useUnoSelector } = UnoStoreHooks;
const { GridView } = UiComponents;

const ApplicationCategoryTab = ({ UNO_URL, token, categoryId, search, assignedApp = [] }) => {
  const configData = useUnoSelector((state) => state.config);
  let [list, setList] = useState([]);
  let [loading, setLoading] = useState(true);

  let getApplications = async () => {
    setLoading(true);
    try {
      let data = await tagCategoryApplication(UNO_URL, token, categoryId);
      setList(data || []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getApplications();
  }, [categoryId]);

  let filterList = list.filter(
    (app) => app?.name?.toLowerCase()?.includes(search?.toLowerCase()) && app.uuid !== configData.config.applicationId
  );

  return (
    <>
      <div className="list-parent list-parent2 h-100">
        {/* <div className="h-100"> */}
        {loading ? (
          <ApplicationSkeleton length={4} />
        ) : (
          <>
            {filterList.length > 0 ? (
              <>
                <GridView>
                  {filterList.map((app, i) => {
                    let checkAppIsAssigned = assignedApp.find((item) => item.uuid === app.uuid);
                    return <ApplicationCard item={app} IsAppAssigned={checkAppIsAssigned} />;
                  })}
                </GridView>
                {/* <div className="tagLine">
                  <h1>
                    <span>Mastering Skills,</span> <span>Empowering Futures.</span>
                  </h1>
                  <p>Made in India ❤️ from Simulanis Solution</p>
                </div> */}
              </>
            ) : (
              <>
                <div className="no-data2">
                  <NoDataFound headText="No Application found." infoText="" />
                </div>
                {/* <div className="tagLine">
                  <h1>
                    <span>Mastering Skills,</span> <span>Empowering Futures,</span>
                  </h1>
                  <p>Made in India ❤️ from Simulanis Solution</p>
                </div> */}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default ApplicationCategoryTab;
